<template>
  <div>
    <v-form ref="TEST_PAIES" @submit.prevent="sectionSave" lazy-validation>
      <div>
        <section-header :ressource="ressource"
                        :isExtended="true"
                        :dialog="false"
                        ref="TEST_PAIES">
        </section-header>
        <div id="field-container">
          <select-field ref="CONVENTION_BRANCHE_LIST"
                        :value=selectedConvention
                        :items=listConvention
                        :disabled=false
                        :editFieldInfo=conventionFieldInfo
                        :required=true
                        @updated=conventionUpdated
                        selectText="Sélectionner une convention">
          </select-field>

          <select-field ref="EMPLOI_LIST"
                        :value=selectedEmploi
                        :items=listEmploi
                        :disabled=false
                        :editFieldInfo=emploiFieldInfo
                        :required=true
                        @updated=emploiUpdated
                        selectText="Sélectionner un emploi">
          </select-field>

          <select-field ref="EFFECTIF_LIST"
                        :value=selectedEffectif
                        :items=listEffectif
                        :disabled=false
                        :editFieldInfo=effectifFieldInfo
                        :required=true
                        @updated=effectifUpdated
                        selectText="Sélectionner l'effectif">
          </select-field>

          <select-field ref="LOCALISATION_LIST"
                        :value=selectedLocalisation
                        :items=listLocalisation
                        :disabled=false
                        :editFieldInfo=localisationFieldInfo
                        :required=true
                        @updated=localisationUpdated
                        selectText="Sélectionner une localisation">
          </select-field>

          <div>
            <v-row class="m-0">
              <check-field ref="ASSOCIATION"
                           :value=association
                           :editFieldInfo=associationFieldInfo
                           :dataTable=true
                           @updated="associationUpdated">
              </check-field>
              <check-field v-if="association"
                           ref="SOUMIS"
                           :value=soumis
                           :editFieldInfo=soumisFieldInfo
                           :dataTable=true
                           @updated="soumisUpdated">
              </check-field>
            </v-row>
          </div>

          <check-field ref="REDUCTION"
                       :value=reduction
                       :editFieldInfo=reductionFieldInfo
                       :dataTable=true
                       @updated="reductionUpdated">
          </check-field>
          <check-field ref="EXONERATION"
                       :value=exoneration
                       :editFieldInfo=exonerationFieldInfo
                       :dataTable=true
                       @updated="exonerationUpdated">
          </check-field>
          <check-field v-if="testPaie.canAbattement"
                       ref="ABATTEMENT"
                       :value=abattement
                       :editFieldInfo=abattementFieldInfo
                       :dataTable=true
                       @updated="abattementUpdated">
          </check-field>
          <div>
            <section-header :ressource="sectionRubriquesVariables"
                            :isExtended="true"
                            :dialog="false"
                            :canAdd="true"
                            addLabel="Ajouter"
                            :disableExtend="true"
                            @callback="addRubriques">
            </section-header>
            <v-col cols="12">
              <v-row v-for="(rubrique, index) in rubriques" :key="index">
                <v-col class="py-0">
                  <date-field ref="SALARIE_DATE_HANDICAP"
                              :value=rubrique.date
                              :editFieldInfo=dateFieldInfo
                              @updated="(value) => dateUpdated(index, value)">
                  </date-field>
                </v-col>
                <v-col class="py-0">
                  <select-field ref="ACTIVITE_LIST"
                                :value=getRubriqueValue(rubrique)
                                :items=listRubriques
                                :disabled=false
                                :editFieldInfo=activiteFieldInfo
                                :required=true
                                @updated="(value) => rubriqueUpdated(index, value)"
                                selectText="Sélectionner une activité">
                  </select-field>
                </v-col>
                <v-col class="py-0">
                  <edit-field v-if="isRubrique(index)"
                              ref="NOMBRE"
                              :value=rubrique.quantite
                              :editFieldInfo=nombreEditFieldInfo
                              @updated="(value) => nombreUpdated(index, value)"
                              :hideLabel=false>
                  </edit-field>
                  <span v-else>Nombre<br>1.00</span>
                </v-col>
                <v-col class="py-0">
                  <edit-field ref="MONTANT"
                              :value=rubrique.rbase
                              :editFieldInfo=montantEditFieldInfo
                              @updated="(value) => montantUpdated(index, value)"
                              :hideLabel=false>
                  </edit-field>
                </v-col>
                <v-col class="col-1 px-1 py-3 d-flex flex-column justify-center justify-space-between">
                  <div class="d-flex justify-center">
                    <v-img src='@/assets/SVG/poubelle.svg' @click="deleteRubrique(index)" style="max-width:15px;">
                    </v-img>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row-reverse">
        <loader-button class="ms-2"
                       type="submit"
                       :label="calculLabel"
                       :loading="calculLoading"
                       :disabled="!canCalcul">
        </loader-button>
        <loader-button class="ms-2"
                       type="button"
                       :label="exportLabel"
                       :disabled="!canExport"
                       :loading="exportLoading"
                       @callback="exportTest">
        </loader-button>
        <!--<loader-button class="ms-2"
                       type="button"
                       :label="displayLabel"
                       :disabled="!canDisplay"
                       :loading="displayLoading"
                       @callback="display">
        </loader-button>-->
      </div>
    </v-form>
    <section-header :ressource="sectionDonneesPaie"
                    :isExtended="true"
                    :dialog="false"
                    :disableExtend="true"
                    ref="DONNEES_PAIE">
    </section-header>
    <div>
      <v-table v-if="donneesPaie.length > 0" dense>
        <thead class="pb-1">
          <tr class="font-weight-bold">
            <td>Key</td>
            <td>Value</td>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in donneesPaie" :key="index">
            <td class="edit-field text-left">{{ item.text }}</td>
            <td class="edit-field text-left">{{ item.value }}</td>
          </tr>
        </tbody>
      </v-table>
    </div>
    <section-header :ressource="sectionCotisations"
                    :isExtended="true"
                    :dialog="false"
                    :disableExtend="true"
                    ref="COTISATIONS">
    </section-header>
    <div>
      <v-table v-if="cotisationsPaie.length > 0" dense>
        <thead class="pb-1">
          <tr class="font-weight-bold">
            <td>Libellé</td>
            <td>Groupe</td>
            <td>Base</td>
            <td>Taux patronal</td>
            <td>Taux salarial</td>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in cotisationsPaie" :key="index">
            <td class="edit-field text-left">{{ item.label }}</td>
            <td class="edit-field text-left">{{ item.group }}</td>
            <td class="edit-field text-left">{{ item.rBase }}</td>
            <td class="edit-field text-left">{{ item.tauxPatronal }}</td>
            <td class="edit-field text-left">{{ item.tauxSalarial }}</td>
          </tr>
        </tbody>
      </v-table>
    </div>
  </div>
</template>

<script lang="ts">
  import {
    GenControl,
    GenSection,
    RessourceGenControl,
    RessourceGenSection
  } from '@/generated/ressources/generatedRessources';
  import {
    AppButtons,
    RessourceAppButton,
    AppControls,
    RessourceAppControl,
    FwkControls,
    RessourceFwkControl,
    AppSections,
    RessourceAppSection
  } from '@/ressources/globalRessources';
  import { RessourceFwkButton, FwkButtons } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { FieldInfo, EditFieldType, EditFieldTheme } from '@/framework/base/components/FieldInfo';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import Item from '@/framework/base/classes/Item';
  import SelectField from '@/framework/base/components/SelectField.vue';
  import { RubriquePaie } from '@/generated/classes/Rubrique';
  import CheckField from '@/framework/base/components/CheckField.vue';
  import EditField from '@/framework/base/components/EditField.vue';
  import DateField from '@/framework/base/components/DateField.vue';
  import TestPaie, { SelectItem } from '@/generated/classes/TestPaie';
  import { Cotisation } from '@/generated/classes/Paie';
  import Files, { DownloadData } from '@/generated/classes/Files';
  import { getBlob } from '@/framework/files/helpers/FileTypes';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import { storeDocument } from '@/generated/stores';
  import { ListFilter } from '../../generated/classes/ListData';
  import { RubriqueCategorys } from '@/generated/classes/Rubrique';
  import { storeRubrique } from '@/generated/stores';
  import { defineComponent, type PropType } from "vue";

  export default defineComponent({
    name: 'SectionParametresPaies',
    components: {
      SectionHeader,
      LoaderButton,
      SelectField,
      CheckField,
      EditField,
      DateField,
      ButtonPlus
    },
    props: {
      hideTitle: {
        type: Boolean,
        required: false,
      },
    },
    data() {
      return {
        canCalcul: false,
        canExport: false,
        canDisplay: false,
        selectedConvention: "",
        listConvention: [] as Item[],
        selectedEmploi: "",
        listEmploi: [] as Item[],
        selectedEffectif: "",
        listEffectif: [] as Item[],
        selectedLocalisation: "",
        listLocalisation: [] as Item[],
        listRubriques: [] as Item[],
        rubriques: [] as RubriquePaie[],
        donneesPaie: [] as SelectItem[],
        cotisationsPaie: [] as Cotisation[],
        reduction: false,
        exoneration: false,
        abattement: false,
        association: false,
        soumis: false,
        calculLoading: false,
        exportLoading: false,
        displayLoading: false,
        sectionName: Sections.PARAMETRES_PAIE,
        testPaie: new TestPaie(),
      };
    },
    computed: {
      calculLabel(): any {
        return RessourceAppButton(AppButtons.CALCULER).label;
      },
      exportLabel(): string {
        return RessourceFwkButton(FwkButtons.EXPORTER).label;
      },
      displayLabel(): string {
        return RessourceFwkButton(FwkButtons.VISUALISER).label;
      },
      ressource(): any {
        return RessourceGenSection(GenSection.PARAMETRES_PAIE);
      },
      sectionRubriquesVariables(): any {
        return RessourceAppSection(AppSections.RUBRIQUES_VARIABLES);
      },
      sectionDonneesPaie(): any {
        return RessourceAppSection(AppSections.DONNEES_PAIE);
      },
      sectionCotisations(): any {
        return RessourceAppSection(AppSections.COTISATIONS);
      },
      ressourceConvention(): any {
        return RessourceGenControl(GenControl.ETABLISSEMENT_IDENTITE_CONVENTION_BRANCHE_LIST);
      },
      ressourceEmploi(): any {
        return RessourceGenControl(GenControl.CONTRAT_SALARIE_EMPLOI_SELECT);
      },
      ressourceLocalisation(): any {
        return RessourceAppControl(AppControls.LOCALISATION);
      },
      ressourceEffectif(): any {
        return RessourceAppControl(AppControls.EFFECTIF);
      },
      ressourceReduction(): any {
        return RessourceAppControl(AppControls.REDUCTION);
      },
      ressourceExoneration(): any {
        return RessourceAppControl(AppControls.EXONERATION);
      },
      ressourceAbattement(): any {
        return RessourceAppControl(AppControls.ABATTEMENT);
      },
      ressourceAssociation(): any {
        return RessourceAppControl(AppControls.ASSOCIATION);
      },
      ressourceSoumis(): any {
        return RessourceAppControl(AppControls.SOUMIS);
      },
      ressourceActivite(): any {
        return RessourceGenControl(GenControl.CRENEAUX_ACTIVITE_SELECT);
      },
      ressourceNombre(): any {
        return RessourceAppControl(AppControls.NOMBRE);
      },
      ressourceMontant(): any {
        return RessourceFwkControl(FwkControls.MONTANT);
      },
      ressourceDate(): any {
        return RessourceAppControl(AppControls.DATE);
      },
      conventionFieldInfo(): FieldInfo {
        const type = EditFieldType.SELECT;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceConvention, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      emploiFieldInfo(): FieldInfo {
        const type = EditFieldType.SELECT;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceEmploi, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      localisationFieldInfo(): FieldInfo {
        const type = EditFieldType.SELECT;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceLocalisation, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      effectifFieldInfo(): FieldInfo {
        const type = EditFieldType.SELECT;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceEffectif, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      reductionFieldInfo(): FieldInfo {
        const type = EditFieldType.BOOL;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceReduction, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      exonerationFieldInfo(): FieldInfo {
        const type = EditFieldType.BOOL;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceExoneration, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      abattementFieldInfo(): FieldInfo {
        const type = EditFieldType.BOOL;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceAbattement, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      associationFieldInfo(): FieldInfo {
        const type = EditFieldType.BOOL;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceAssociation, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      soumisFieldInfo(): FieldInfo {
        const type = EditFieldType.BOOL;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceSoumis, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      activiteFieldInfo(): FieldInfo {
        const type = EditFieldType.SELECT;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceActivite, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      nombreEditFieldInfo(): FieldInfo {
        const type = EditFieldType.DECIMAL;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceNombre, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      montantEditFieldInfo(): FieldInfo {
        const type = EditFieldType.DECIMAL;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceMontant, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
      dateFieldInfo(): FieldInfo {
        const type = EditFieldType.DATE;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = null;
        const live = null;
        return new FieldInfo(this.ressourceDate, type, precision, mask, format, focus, live, EditFieldTheme.BASIC);
      },
    },
    created(): void {
      storeDocument.registerDocument();
      TestPaie.calcul(this.testPaie).then((res) => {
        this.updateData(res);
      })
    },
    methods: {
      updateData(result: TestPaie): void {
        this.reduction = result.reduction;
        this.rubriques = result.rubriques;
        this.exoneration = result.exoneration;
        this.abattement = result.abattement;
        this.donneesPaie = result.donneesPaie;
        this.cotisationsPaie = result.cotisationsPaie;

        result.conventionArray.forEach((item) => {
          if (!this.listConvention.find(e => e.title === item.text)) {
            this.listConvention.push(new Item(parseInt(item.value), item.text));
          }
          });
        result.emploiArray.forEach((item) => {
          if (!this.listEmploi.find(e => e.title === item.text)) {
            this.listEmploi.push(new Item(parseInt(item.value), item.text));
          }
        });
        result.localisationArray.forEach((item) => {
          if (!this.listLocalisation.find(e => e.title === item.text)) {
            this.listLocalisation.push(new Item(parseInt(item.value), item.text));
          }
        });
        result.effectifArray.forEach((item) => {
          if (!this.listEffectif.find(e => e.title === item.text)) {
            this.listEffectif.push(new Item(parseInt(item.value), item.text));
          }
        });
        result.rubriqueArray.forEach((item) => {
          if (!this.listRubriques.find(e => e.title === item.text)) {
            this.listRubriques.push(new Item(parseInt(item.value), item.text));
          }
        });

        if (this.rubriques.length == 0) {
          this.addRubriques();
        }
        this.testPaie = result;
        this.canCalcul = result.canCalcul;
        this.canExport = result.canExport;
        this.canDisplay = result.canDisplay;
        this.testPaie.calcul = false;
      },
      getRubriqueValue(rubrique: RubriquePaie): string {
        let res = "";
        const item = this.listRubriques.find(a => a.key == rubrique.rubriqueId);
        if (item) {
          res = item.title;
        }
        return res;
      },
      conventionUpdated(item: Item) {
        this.selectedConvention = item.title;
        this.testPaie.conventionId = item.key;
        this.setUpdated();
      },
      emploiUpdated(item: Item) {
        this.selectedEmploi = item.title;
        this.testPaie.emploiId = item.key;
        this.setUpdated();
      },
      effectifUpdated(item: Item) {
        this.selectedEffectif = item.title;
        this.testPaie.effectifId = item.key;
        this.setUpdated();
      },
      localisationUpdated(item: Item) {
        this.selectedLocalisation = item.title;
        this.testPaie.localisationId = item.key;
        this.setUpdated();
      },
      reductionUpdated(value: boolean) {
        this.reduction = value;
        this.testPaie.reduction = value;
        this.setUpdated();
      },
      exonerationUpdated(value: boolean) {
        this.exoneration = value;
        this.testPaie.exoneration = value;
        this.setUpdated();
      },
      abattementUpdated(value: boolean) {
        this.abattement = value;
        this.testPaie.abattement = value;
        this.setUpdated();
      },
      associationUpdated(value: boolean) {
        this.association = value;
        this.testPaie.association = value;
        this.setUpdated();
      },
      soumisUpdated(value: boolean) {
        this.soumis = value;
        this.testPaie.soumis = value;
        this.setUpdated();
      },
      dateUpdated(index: number, date: Date) {
        const rubrique = this.rubriques[index];
        rubrique.date = date;
        this.testPaie.rubriques = this.rubriques;
        this.setUpdated();
      },
      rubriqueUpdated(index: number, item: Item) {
        const rubrique = this.rubriques[index];
        rubrique.rubriqueId = item.key;
        this.testPaie.rubriques = this.rubriques;
        this.setUpdated();
      },
      nombreUpdated(index: number, nombre: string) {
        const value = parseInt(nombre);
        if (!isNaN(value)) {
          const rubrique = this.rubriques[index];
          rubrique.quantite = value;
          this.testPaie.rubriques = this.rubriques;
          this.setUpdated();
        }
      },
      montantUpdated(index: number, montant: string) {
        const value = parseInt(montant);
        if (!isNaN(value)) {
          const rubrique = this.rubriques[index];
          rubrique.rbase = value;
          this.testPaie.rubriques = this.rubriques;
          this.setUpdated();
        }
      },
      isRubrique(index: number): boolean {
        const rubriquePaie = this.rubriques[index];
        if (rubriquePaie.rubriqueId > 0) {
          const rubrique = storeRubrique.getRubrique(rubriquePaie.rubriqueId);
          const res = rubrique.category == RubriqueCategorys.CONTRAT;
          if (!res) {
            rubriquePaie.quantite = 1;
          }
          return res;
          ;
        } else {
          return true;
        }
      },
      deleteRubrique(index: number) {
        this.rubriques.splice(index, 1);
        this.setUpdated();
      },
      setUpdated() {
        TestPaie.calcul(this.testPaie).then((res) => {
          this.updateData(res);
        })
      },
      addRubriques() {
        const rubrique = new RubriquePaie();
        rubrique.date = new Date();
        if (this.rubriques.length > 0) {
          rubrique.date = this.rubriques[this.rubriques.length - 1].date;
        }
        this.rubriques.push(rubrique);
        this.setUpdated();
      },
      sectionSave(): void {
        this.testPaie.calcul = true;
        this.canCalcul = false;
        this.calculLoading = true;
        TestPaie.calcul(this.testPaie).then((res) => {
          this.updateData(res);
          this.calculLoading = false;
        })
      },
      exportTest(): void {
        const data = new DownloadData();
        this.exportLoading = true;
        data.service = 'TestPaie';
        data.type.extension = 'xlsx';

        const date = new Date();
        const year = date.toLocaleString("default", { year: "numeric" });
        const month = date.toLocaleString("default", { month: "2-digit" });
        const day = date.toLocaleString("default", { day: "2-digit" });
        const fileName = `${year}-${month}-${day}-${data.service}`; // set table name as default file name
        this.canExport = false;

        Files.download(data)
          .then((buffer) => {
            const blob = getBlob(buffer, data.type.extension);
            const file = window.URL.createObjectURL(blob);
            const docUrl = document.createElement('a');
            docUrl.setAttribute('href', file);
            docUrl.setAttribute('download', `${fileName}.${data.type.extension}`);
            document.body.appendChild(docUrl);
            docUrl.click();
            this.exportLoading = false;
          });
      },
      display() {
        this.displayLoading = true;
        TestPaie.display(this.testPaie).then((res) => {
          this.updateData(res);
          this.displayLoading = false;
        })
      },
    },
  });
</script>